export default __webpack_public_path__ + "static/media/mnschedule_navicon-light.e6144568.svg";